import { FormattedEvent } from '@eventbrite/event-renderer';
import classNames from 'classnames';
import React from 'react';
import {
    GA_EXTERNAL_VIEW_EVENT_ACTION,
    GA_VIEW_EVENT_ACTION,
    GA_VIEW_MORE_ACTION,
} from '../../constants/analytics';
import { FeatureFlags } from '../../types/index';
import DiscoverVerticalEventCard from '../DiscoverEventCard/Vertical/DiscoverVerticalBrowseEventCard';
import { SeeMoreButton } from '../SeeMoreButton';

interface FormattedEventWithStatsig extends FormattedEvent {
    statsigLocationString: string;
}

const getCards = ({
    isSmallCity,
    cards,
    isAuthenticated,
    onTrackClick,
    onTrackClickInternal,
    affCode,
    locale,
}: {
    isSmallCity: boolean;
    cards: FormattedEventWithStatsig[];
    locale: string;
    isAuthenticated: boolean;
    onTrackClick: Function;
    onTrackClickInternal?: Function;
    affCode?: string;
}) => {
    const cardsArrayLength = cards.length;
    return cards.map(
        ({ id, statsigLocationString, ...cardProps }, index: number) => {
            const shouldTrimOddCard =
                cardsArrayLength % 2 === 1 &&
                index === cardsArrayLength - 1 &&
                !isSmallCity;
            const classes = classNames(
                'eds-l-pad-all--3',
                'eds-g-cell',
                'eds-g-cell--has-overflow',
                'eds-g-cell-md-4-12',
                'eds-g-cell-sm-6-12',
                'eds-g-cell-1-1',
                {
                    //hide extraneous cards
                    'eds-show-up-sm': index > 2 && !isSmallCity,
                    //trim odd card so doesnt look wierd on medium breakpoints
                    'eds-hide-sm eds-hide-sw eds-hide-mn': shouldTrimOddCard,
                },
            );

            return (
                <div className={classes} key={id}>
                    <DiscoverVerticalEventCard
                        event={{ ...cardProps, id }}
                        statsigLocationString={statsigLocationString}
                        isAuthenticated={isAuthenticated}
                        affCode={affCode}
                        locale={locale}
                        onClick={() => {
                            const action =
                                cardProps.ticketsBy === 'Eventbrite'
                                    ? GA_VIEW_EVENT_ACTION
                                    : GA_EXTERNAL_VIEW_EVENT_ACTION;
                            onTrackClick?.(
                                { id },
                                action,
                                cardProps.organizerFollowerCount,
                            );
                            onTrackClickInternal?.(
                                index,
                                id,
                                cardProps.ticketsBy,
                            );
                        }}
                    />
                </div>
            );
        },
    );
};

export const BigEventCardGroup = ({
    cards,
    linkUrl,
    isAuthenticated,
    onTrackClick,
    isSmallCity,
    title,
    onTrackClickInternal,
    affCode,
    locale,
}: {
    cards: FormattedEventWithStatsig[];
    linkUrl?: string;
    isAuthenticated: boolean;
    onTrackClick: Function;
    isSmallCity: boolean;
    locale: string;
    title?: string;
    onTrackClickInternal?: Function;
    trackGAEvent?: Function;
    experiments: any;
    featureFlags: FeatureFlags;
    affCode?: string;
}) => (
    <div className="eds-g-group">
        {getCards({
            isSmallCity,
            cards,
            isAuthenticated,
            onTrackClick,
            onTrackClickInternal,
            affCode,
            locale,
        })}
        <div className="eds-show-down-sn eds-align--center">
            <div className="eds-g-cell">
                <SeeMoreButton
                    linkUrl={linkUrl || ''}
                    trackClick={onTrackClick}
                    title={title || ''}
                    gaAction={GA_VIEW_MORE_ACTION}
                />
            </div>
        </div>
    </div>
);

export default BigEventCardGroup;
